<script lang="ts">
import {defineComponent} from 'vue'
import {useAuthStore} from "@/stores/auth.store"
import Header from "@/components/Global/Layout/Header.vue"

export default defineComponent({
  name: "PageWithLeftMenu",
  components: {
    Header,
  },
  data() {
    return {
      authStore: useAuthStore()
    }
  },
  computed: {
    window() {
      return window
    },
  },
  methods: {
    toggleMenu() {
      document.querySelector('.menu_container')?.classList.toggle('show')
      document.querySelector('.page')?.classList.toggle('with_nav')
    },
    hideWhenClickMobile(e: Event){
      const element = e.target as HTMLElement
      const parentElement = element.parentElement as HTMLElement
      if(window.innerWidth <= 750 &&
          (element.classList.contains('p-menu-item-link') ||
              (parentElement && parentElement.classList.contains('p-menu-item-link')))){
        document.querySelector('.left_menu')?.classList.remove('show')
        document.querySelector('.page')?.classList.remove('with_nav')
      }
    },
  }
})
</script>

<template>
  <Header class="header" @toggleMenu="toggleMenu"></Header>
  <div class="page_with_nav">
    <slot name="left_menu" v-if="authStore.isLoggedIn" @click="hideWhenClickMobile"></slot>
    <div :class="'page' + (window.innerWidth > 750 ? ' with_nav' : '')" :style="!authStore.isLoggedIn ? 'left: 0px': ''">
      <div id="menu_filter" @click="toggleMenu"></div>
      <RouterView />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/global/variables" as *;

.impersonating_header{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: $dataview_item_background_color_light;
  padding: 0.5rem 1rem;
  z-index: 999;
  height: 2.8rem;
}

.theme-dark{
  .impersonating_header{
    background-color: $dataview_item_background_color_dark;
  }
}
.header{
  position: fixed;
  left: 0;
  right: 0;
  border: 0;
  border-radius: 0;
  top: 0;
  height: 3.5rem;
  z-index: 400;
  box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.1);
}
.page_with_nav.impersonating:deep(){
  .page{
    margin-top: calc(2.8rem + 3.5rem);
  }
  .menu_container{
    top: calc(2.8rem + 3.5rem);
  }
}
.page_with_nav:deep() {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 1rem;
  .page{
    margin-top: 4rem;
    margin-left: 0;
    width: 100%;
    transition-duration: .3s;
    &.with_nav{
      margin-left: 14rem;
      width: calc(100% - 14rem);
    }
  }
  .menu_container{
    border: 0;
    border-radius: 0;
    width: 14rem;
    bottom: 0;
    position: fixed;
    top: 3.5rem;
    left: -100%;
    transition-duration: .3s;
    z-index: 999;
    max-height: calc(100vh - 3rem);
    overflow-y: auto;
    --sb-track-color: #232E33;
    --sb-thumb-color: #6BAF8D;
    --sb-size: 2px;
    box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.1);

    &::-webkit-scrollbar {
      width: var(--sb-size);
    }

    &::-webkit-scrollbar-track {
      background: var(--sb-track-color);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--sb-thumb-color);
      border-radius: 3px;
    }
    &.show{
      left: 0;
    }
  }
  @media (max-width: 750px){
    .left_menu .show{
      left: 0;
    }
    .page{
      margin-left: 0;
      &.with_nav{
        margin-left: 0;
        width: 100%;
        #menu_filter{
          display: block;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.8);
          z-index: 398;
        }
      }
    }
  }
}
</style>
